document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.auto-slideshow').forEach(function (root) {
    var slides = root.querySelectorAll('.auto-slideshow__slide');
    var dots = root.querySelectorAll('.auto-slideshow__dot');
    var speed = parseInt(root.dataset.autoplaySpeed, 10) || 4000;
    var current = 0;
    var timer = null;

    if (slides.length < 2) return;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() {
      goTo(current + 1);
    }

    function start() {
      stop();
      timer = setInterval(next, speed);
    }

    function stop() {
      if (timer) clearInterval(timer);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    start();
  });
});